import { ChildComponentType } from './childComponentType';
import { InWindowChildComponent } from './inWindow/childComponent';
import { CrossWindowChildComponent } from './crossWindow/index';
/**
 * Factory to create child components.
 */
var ChildComponentFactory = /** @class */ (function () {
    function ChildComponentFactory() {
    }
    /**
     * Create a child component.
     *
     * @param window The window reference.
     * @param options The child component options.
     * @param rootFacade The facade for the root component.
     */
    ChildComponentFactory.prototype.createComponent = function (window, options, rootFacade) {
        switch (options.type) {
            case ChildComponentType.InWindow:
                return new InWindowChildComponent(window, options, rootFacade);
            case ChildComponentType.CrossWindow:
                return new CrossWindowChildComponent(window, options, rootFacade);
            default:
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                throw new Error("The \"".concat(options.type, "\" is not configured."));
        }
    };
    return ChildComponentFactory;
}());
export { ChildComponentFactory };
//# sourceMappingURL=childComponentFactory.js.map